<template>
  <page>
    <form data-vv-scope="batchRiOutwardsRelForm">
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Date Range</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex lg6 md6 xs12 sm6>
                      <cal-picker
                        v-model="forms.tranDateFrom"
                        :label="labels.tranDateFrom"
                        :data-vv-as="labels.tranDateFrom"
                        :error-messages="errors.collect('forms.tranDateFrom')"
                        data-vv-name="forms.tranDateFrom"
                        v-validate="doValidateDateFrom"
                        :max="new Date()"
                      ></cal-picker>
                    </v-flex>
                    <v-flex lg6 md6 xs12 sm6>
                      <cal-picker
                        v-model="forms.tranDateTo"
                        :label="labels.tranDateTo"
                        :data-vv-as="labels.tranDateTo"
                        :error-messages="errors.collect('forms.tranDateTo')"
                        data-vv-name="forms.tranDateTo"
                        v-validate="doValidateDateTo"
                        :max="new Date()"
                      ></cal-picker>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-3"></v-spacer>
      <v-expansion-panels v-model="panel2" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex lg6 md6 xs12 sm6>
                      <v-text-field
                        v-model="forms.polNoFrom"
                        :label="labels.polNoFrom"
                        :error-messages="errors.collect('forms.polNoFrom')"
                        data-vv-name="forms.polNoFrom"
                        :data-vv-as="labels.polNoFrom"
                        readonly
                        clearable
                      >
                        <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                          <v-icon color="info" @click="getPolNoHelpList('polNoFrom')" v-text="'mdi-magnify'"></v-icon>
                        </v-slide-x-reverse-transition>
                      </v-text-field>
                    </v-flex>
                    <v-flex lg6 md6 xs12 sm6>
                      <v-text-field
                        v-model="forms.polNoTo"
                        :label="labels.polNoTo"
                        :error-messages="errors.collect('forms.polNoTo')"
                        data-vv-name="forms.polNoTo"
                        :data-vv-as="labels.polNoTo"
                        v-validate="doValidatePolNoTo"
                        readonly
                        clearable
                      >
                        <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                          <v-icon color="info" @click="getPolNoHelpList('polNoTo')" v-text="'mdi-magnify'"></v-icon>
                        </v-slide-x-reverse-transition>
                      </v-text-field>
                    </v-flex>
                    <v-flex lg6 md6 xs12 sm6>
                      <v-text-field
                        v-model="forms.polType"
                        :label="labels.polType"
                        :error-messages="errors.collect('forms.polType')"
                        data-vv-name="forms.polType"
                        :data-vv-as="labels.polType"
                        append-icon="mdi-magnify"
                        @click:append="getHelpList('polType')"
                        readonly
                        v-validate="'required'"
                      >
                        <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                          <v-icon color="info" @click="getHelpList('polType')"></v-icon>
                        </v-slide-x-reverse-transition>
                      </v-text-field>
                    </v-flex>
                    <v-flex lg6 md6 xs12 sm6>
                      <v-text-field
                        v-model="forms.branch"
                        :label="labels.branch"
                        :error-messages="errors.collect('forms.branch')"
                        data-vv-name="forms.branch"
                        :data-vv-as="labels.branch"
                        append-icon="mdi-magnify"
                        @click:append="getHelpList('branch')"
                        readonly
                        v-validate="'required'"
                      >
                        <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                          <v-icon color="info" @click="getHelpList('branch')"></v-icon>
                        </v-slide-x-reverse-transition>
                      </v-text-field>
                    </v-flex>
                    <v-flex lg6 md6 xs12 sm6>
                      <v-autocomplete
                        :items="printTransList"
                        v-model="forms.printTrans"
                        :label="labels.printTrans"
                        item-text="label"
                        item-value="value"
                        data-vv-name="forms.printTrans"
                        :data-vv-as="labels.printTrans"
                        :error-messages="errors.collect('forms.printTrans')"
                        v-validate="'required'"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex lg6 md6 xs12 sm6>
                      <v-checkbox color="primary" :label="labels.printListAE" v-model="forms.printListAE" :disabled="disableRelease"></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-btn class="mt-2" color="primary" dark @click.prevent="doSubmit" :loading="submitting">
        <v-icon dark left>mdi-arrow-right-bold-box</v-icon>
        {{ actionLabel.release }}
      </v-btn>
    </form>
    <v-dialog v-model="showRiOutwardsHelpList" width="1280px">
      <ri-outwards-help-list
        @close="showRiOutwardsHelpList = false"
        :boolRefresh="showRiOutwardsHelpList"
        @assign-ri="assignRiOutwards"
      ></ri-outwards-help-list>
    </v-dialog>
    <v-dialog v-model="HelpList" width="900px" persistent>
      <help-list
        :apiURI="apiURI"
        :mode="mode"
        :param="param"
        :defAll="defAll"
        :boolRefresh="HelpList"
        @close="doClose"
        @doAssign="doAssign($event)"
      ></help-list>
    </v-dialog>
    <v-dialog v-model="processingFlag" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Processing Batch Release...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="promptExeJob" width="500px" persistent>
      <batch-job-scheduler
        v-if="promptExeJob"
        :skipValidate="batchForm.skipValidate"
        :jobKeys="forms"
        :showJobMode="false"
        @close="promptExeJob = false"
        @doPopulate="processBatch($event)"
      />
    </v-dialog>

    <warning v-model="promptResubmit" @ok="doAccept">
      <div>{{ warningMsg1 }}</div>
      <div class="queryValue" v-for="(item, index) in bchJobDetails" :key="index">{{ item }}</div>
      <div>{{ warningMsg2 }}</div>
    </warning>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import RiOutwardsHelpList from '@/components/core/common/dialog/RiOutwardsHelpList'
import HelpList from '@/components/core/common/dialog/HelpList'
import clone from 'clone'
import BatchJobScheduler from '@/components/core/common/BatchJobScheduler'
import { batchManagerMixin } from '@/mixins/common/batchManagerMixin'

export default {
  data() {
    return {
      labels: {
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        polNoFrom: 'Policy No. From',
        polNoTo: 'Policy No. To',
        polType: 'Policy Type',
        branch: 'Branch',
        printTrans: 'Print Transactions',
        printListAE: 'Print list and do not release'
      },
      actionLabel: {
        release: 'Release'
      },
      forms: {
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        polNoFrom: '',
        polNoTo: '',
        polType: 'All',
        branch: 'All',
        printTrans: 'R',
        printListAE: true
      },
      printTransList: [
        { label: 'Both', value: 'B' },
        { label: 'Released', value: 'R' },
        { label: 'Unreleased', value: 'U' }
      ],
      showRiOutwardsHelpList: false,
      HelpList: false,
      mode: '',
      param: '',
      defAll: '',
      apiURI: '',
      submitting: false,
      processingFlag: false,
      disableRelease: true,
      panel: [0],
      panel2: [0]
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('specialFuncUWInit')])
    },
    getPolNoHelpList(fieldName) {
      this.polNoField = fieldName
      this.showRiOutwardsHelpList = true
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      this.param = ''
      this.defAll = true
      if (fieldName === 'branch') {
        this.apiURI = this.$store.state.commons.menu.getBranchList
        this.param = this.forms.branch
      } else if (fieldName === 'polType') {
        this.apiURI = this.$store.state.commons.menu.getPolicyTypeList
        this.param = this.forms.polType
      }
      this.HelpList = true
    },
    assignPolicy(data) {
      if (this.polNoField === 'polNoFrom') {
        this.forms.polNoFrom = data
      } else if (this.polNoField === 'polNoTo') {
        this.forms.polNoTo = data
      }
    },
    assignRiOutwards(data) {
      if (this.polNoField === 'polNoFrom') {
        this.forms.polNoFrom = data
      } else if (this.polNoField === 'polNoTo') {
        this.forms.polNoTo = data
      }
    },
    doClose() {
      this.HelpList = false
    },
    doAssign(Obj) {
      switch (this.mode) {
        case 'branch':
          this.forms.branch = ''
          this.forms.branch = Obj.finalSelectedItems.toString()
          break
        case 'polType':
          this.forms.polType = ''
          this.forms.polType = Obj.finalSelectedItems.toString()
          break
      }
    },
    doSubmit() {
      this.promptResubmit = false
      this.resetMessages()
      this.$validator.validateAll('batchRiOutwardsRelForm').then((result) => {
        if (result) {
          if (this.isBatchManager === true) {
            this.promptExeJob = true
          } else {
            this.processBatchPolicyRelease()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processBatchPolicyRelease() {
      const apiURI = this.$store.state.underwriting.specialFuncUWSettings.menu.processBatchRiOutwardsRelease
      let messageFilters = clone(this.forms)
      if (apiURI) {
        try {
          this.processingFlag = true
          const result = await this.$http.post(apiURI, messageFilters)
          if (result.data) {
            this.processingFlag = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processingFlag = false
        }
      } else {
        this.$toast.error('An error encountered unable to proceed.')
        this.processingFlag = false
      }
    },
    async processBatch(bmgForms) {
      const apiURI = this.$store.state.underwriting.specialFuncUWSettings.menu.exeBatchRiOutwardsRelease
      if (apiURI) {
        try {
          this.submitting = true
          const result = await this.$http.post(apiURI, bmgForms)
          if (result.data) {
            const { data } = result.data
            if (data.prevBchJobs && data.prevBchJobs.length > 0) {
              this.promptResubmit = true
              this.getBchJobDetails(data.prevBchJobs)
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
      this.batchForm.skipValidate = false
    }
  },
  computed: {
    doValidateDateFrom() {
      const today = new Date()
      if (this.forms.tranDateFrom !== '' && this.forms.tranDateFrom !== undefined) {
        return 'required|valMaxDate:' + today
      } else {
        return 'required'
      }
    },
    doValidateDateTo() {
      if (
        this.forms.tranDateTo !== '' &&
        this.forms.tranDateFrom !== '' &&
        this.forms.tranDateTo !== undefined &&
        this.forms.tranDateFrom !== undefined
      ) {
        return 'required|valMinDate:' + this.forms.tranDateFrom
      } else {
        return 'required'
      }
    },
    doValidatePolNoTo() {
      if (this.forms.polNoFrom !== '' && this.forms.polNoTo === '') {
        return 'required'
      } else {
        return ''
      }
    }
  },
  created() {
    this.$validator.extend('valMaxDate', {
      getMessage(field, args) {
        return 'Cannot be later than System Date'
      },
      validate(value, args) {
        let maxDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(maxDate))
        } else return true
      }
    })
    this.$validator.extend('valMinDate', {
      getMessage(field, args) {
        return 'Cannot be earlier than From Date'
      },
      validate(value, args) {
        let mixDate = args[0]
        if (value) {
          return !isAfter(removeTime(mixDate), removeTime(value))
        } else return true
      }
    })
  },
  watch: {
    'forms.printTrans': function (value) {
      if (value && value === 'R') {
        this.disableRelease = true
        this.forms.printListAE = true
      } else {
        this.disableRelease = false
        this.forms.printListAE = false
      }
    },
    'forms.polNoFrom': function (value) {
      if (value && value === undefined && value === '' && value === null) {
        this.forms.polNoTo = ''
      }
    },
    'forms.polNoTo': function (value) {
      if (value && value === undefined && value === '' && value === null) {
        this.forms.polNoFrom = ''
      }
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin, MessageMixin, batchManagerMixin],
  components: {
    RiOutwardsHelpList,
    HelpList,
    BatchJobScheduler
  }
}
</script>
